import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { filter, map, takeWhile, tap } from 'rxjs/operators';
import * as fromLookups from '../../lookups';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromCompanySetting from '../store';
import { CompanySetting } from '../store';
@Component({
    selector: 'ef-company-setting-feature',
    templateUrl: './company-setting-feature.component.html',
    styleUrls: ['./company-setting-feature.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanySettingFeatureComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    process$: Observable<fromShared.Process>;
    settings$: Observable<Array<fromCompanySetting.CompanySetting>>;
    categories$: Observable<{ CatID; Description }[]>;
    payrollFrequency$: Observable<Array<{ Payrollfrequency: number }>>;
    daysOfWeek$: Observable<Array<fromLookups.IDayOfWeek>>;
    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    private active = true;
    constructor(
        private log: LoggingService,
        private store: Store<fromCompanySetting.State>
    ) {
        this.store.dispatch(fromCompanySetting.getCompanySettings());
        this.store.dispatch(
            fromCompanySetting.getCompanySetting({
                SettingType: 'AdminMsg1'
            })
        );

        this.store.dispatch(
            fromCompanySetting.getCompanySetting({
                SettingType: 'MgrMsg1'
            })
        );

        this.store.dispatch(
            fromCompanySetting.getCompanySetting({
                SettingType: 'UserMsg1'
            })
        );
    }
    ngOnInit() {
        this.setupObservables();
        this.setupSubscriptions();
    }
    ngAfterViewInit(): void {}
    ngOnDestroy(): void {
        this.active = false;
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.daysOfWeek$ = this.store.pipe(select(fromLookups.getDaysOfWeek));
        this.payrollFrequency$ = this.store.pipe(
            select(fromLookups.getPayrollFrequency)
        );
        this.settings$ = this.store.pipe(
            select(fromCompanySetting.selectAll),
            tap(settings =>
                this.log.verbose({
                    type: 'CompanySettingFeatureComponent:settings$',
                    settings
                })
            ),
            map(settings => clone(settings) as CompanySetting[]),
            map(settings => settings.filter(z => z.SettingType != "AdminMsg1" && z.SettingType != "MgrMsg1" && z.SettingType != "UserMsg1")),
            map(x =>
                x.map(y => ({
                    ...y,
                    CtrlType: y.CtrlType.toLocaleLowerCase(),
                    SettingValue:
                        y.CtrlType.toLocaleLowerCase() === 'checkbox'
                            ? y.SettingValue === '1'
                            : y.SettingValue
                }))
            )
        );
        this.categories$ = this.store.pipe(
            select(fromCompanySetting.getCategories)
        );
        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors),
            tap(selected =>
                this.log.verbose({
                    type: 'CompanySettingFeatureComponent:selectedError$',
                    selected
                })
            )
        );
        const errors$ = this.store.pipe(select(fromShared.Errors.getErrors));
        this.selectedErrorWithStatus$ = combineLatest([
            this.selectedError$,
            errors$,
            this.settings$.pipe(filter(x => !!x))
        ]).pipe(
            tap(([selected, errors]) =>
                this.log.verbose({
                    type: 'CompanySettingFeatureComponent:errors$',
                    errors,
                    selected
                })
            ),
            map(
                ([selected, errors]) =>
                    errors.filter(
                        e =>
                            e.MsgEntityID === selected.MsgEntityID &&
                            e.MsgProcessID === selected.MsgProcessID
                    )[0]
            ),
            tap(selected =>
                this.log.verbose({
                    type: 'CompanySettingFeatureComponent:errors$:filtered',
                    selected
                })
            )
        );
    }
    setupSubscriptions() {
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
        this.settings$.pipe(takeWhile(() => this.active)).subscribe(settings => {

        });
    }
    onSave(setting: CompanySetting) {
        this.log.verbose({
            type: 'CompanySettingFeatureComponent:onSave',
            setting
        });
        this.store.dispatch(
            fromCompanySetting.putCompanySettings({ settings: [setting] })
        );
    }
    onShowError(event) {
        this.ShowError.next(event);
    }
}
